export default function match(value, cases, defaultValue = null) {
  return cases[value] !== undefined ? cases[value] : defaultValue;
}
